import type { FaceLivenessDetectionError } from "./FaceLivenessDetectionError.js"
import UnknownError from "./UnknownError.js"

const UnknownFaceLivenessDetectionError: FaceLivenessDetectionError = {
	error: UnknownError,
	state: "UNKNOWN_ERROR"
}

export default UnknownFaceLivenessDetectionError
